module.exports = __webpack_public_path__ + "img/bonaire.e0d5d720.svg";